export const DEFAULT_APP_AUTH_TOKEN_KEY = 'token';
export const SELLER_APP_AUTH_TOKEN_KEY = 'token-seller';
export const SHOW_FORM_CREATE_SHOP_WELCOME_MODAL = 'show-form-create-shop-welcome-modal-seller';
export const SELLER_ACCOUNT_ID_KEY = 'account_id';
